var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReport24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.617 2.882C9.754 1.627 10.823 1 12 1s2.246.627 4.384 1.882l1.299.763c2.087 1.225 3.131 1.838 3.704 2.837.572 1 .572 2.21.572 4.631v1.774c0 2.42 0 3.631-.572 4.63-.573 1-1.617 1.613-3.704 2.838l-1.3.763C14.247 22.373 13.178 23 12 23s-2.246-.627-4.383-1.882l-1.3-.763c-2.087-1.225-3.13-1.838-3.703-2.837-.572-1-.572-2.21-.572-4.631v-1.774c0-2.42 0-3.631.572-4.63.572-1 1.616-1.613 3.704-2.838l1.299-.763Zm3.12 3.922a1.263 1.263 0 1 1 2.526 0l-.15 5.413a1.113 1.113 0 0 1-2.225 0l-.15-5.413ZM12 18.494a1.732 1.732 0 1 0 0-3.463 1.732 1.732 0 0 0 0 3.464Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport24);
export default __webpack_public_path__ + "static/media/report_24.d96301b3.svg";
export { ForwardRef as ReactComponent };